import React from "react";
import { Card, CardBody, Progress, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

/**
 * PENDING
 *
 * "Pending" on its own does not tell anyone what to do next, so the number is
 * split into the three stages a job actually sits at before it leaves:
 *
 *   Awaiting Inspection -> Under Repair -> Ready to Dispatch
 */
const STAGE_STYLE = {
  "Pending": { color: "warning", icon: "ri-time-line" },
  "Approved": { color: "info", icon: "ri-tools-line" },
  "Repair Completed": { color: "success", icon: "ri-truck-line" },
};

const PendingJobs = ({ breakdown = [], total = 0, loading = false }) => {
  const navigate = useNavigate();

  return (
    <Card className="h-100">
      <CardBody>
        <div className="d-flex align-items-start justify-content-between mb-3">
          <div>
            <h5 className="card-title mb-1">Pending Jobs</h5>
            <p className="text-muted font-size-12 mb-0">
              Work still in the workshop
            </p>
          </div>

          <Button
            color="link"
            className="p-0 font-size-13 text-decoration-none"
            onClick={() => navigate("/job-card-list")}
          >
            View Job Cards <i className="mdi mdi-chevron-right" />
          </Button>
        </div>

        {loading ? (
          <div className="dashboard-placeholder">Loading...</div>
        ) : (
          <>
            <div className="text-center py-3 mb-3 border-bottom">
              <h1 className="mb-0 fw-bold text-warning">{total}</h1>
              <small className="text-muted">Total pending job cards</small>
            </div>

            {breakdown.map((stage) => {
              const style = STAGE_STYLE[stage.status] || {
                color: "secondary",
                icon: "ri-circle-line",
              };
              const percent = total > 0 ? (stage.count / total) * 100 : 0;

              return (
                <div key={stage.status} className="mb-3">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <span className="font-size-13">
                      <i className={`${style.icon} text-${style.color} me-1`} />
                      {stage.label}
                    </span>
                    <span className="fw-semibold font-size-13">
                      {stage.count}
                    </span>
                  </div>
                  <Progress
                    value={percent}
                    color={style.color}
                    style={{ height: "6px" }}
                  />
                </div>
              );
            })}

            {total === 0 && (
              <p className="text-muted text-center font-size-13 mb-0">
                Nothing pending. The workshop is clear.
              </p>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default PendingJobs;
